import React from 'react'

import Dashboard from '../dashboard'

const InstallationList = () => {
    return (
        <div>
            <Dashboard />
        </div>
    )
}

export default InstallationList
